import React, { useState } from 'react'
import { deleteNotificationChannel } from "@api/merchantsController";
import { Modal, Button } from "@components";
import { toast } from "@components/toast/Toast";

const DeleteSharedMailbox = ({open, onClose, onComplete, mailbox}) => {

  const [loading, setLoading] = useState(false)

  const onSubmit = async () => {
    setLoading(true);
    const response = await deleteNotificationChannel(mailbox.id);
    setLoading(false);

    if (response?.status === 204) {
      toast({ description: `Removed "${mailbox.name}" shared mailbox` });
      onComplete()
      onClose()
      return;
    }

    // The client swallows the error and returns null, so without this the modal would just sit
    // there looking like nothing happened.
    toast({
      title: "Could not remove mailbox",
      description: `"${mailbox.name}" is still receiving notifications. Please try again.`,
    });
  };

  return (
    <Modal isOpen={open} onClose={onClose} title="Remove shared mailbox" size="sm">
      <div className="p-5">
        <p>Are you sure you want to remove {mailbox.name}?</p>
        <p>{mailbox.emailAddress} will stop receiving notifications from Ontik. You can add it again
        at any time, though its notification settings will start from scratch.</p>
      </div>
      <div className="p-4 flex gap-2 justify-end border-t">
        <Button onClick={onClose} disabled={loading} color="secondary">Cancel</Button>
        <Button
          type="submit"
          onClick={() => onSubmit()}
          color="danger"
          submitting={loading}
        >Remove mailbox</Button>
      </div>
    </Modal>
  )
}

export default DeleteSharedMailbox
